module.exports = __webpack_public_path__ + "static/img/qualifications_row_19.f40610a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_19.png
// module id = rJ5F
// module chunks = 1